module.exports = __webpack_public_path__ + "static/media/estampacion.507818c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/estampacion.jpg
// module id = 1294
// module chunks = 0